import React from 'react'
import Styles from "./UserManual.module.scss";
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

import { Typography } from '@mui/material';

export function UserManual({ data, callback, currentIndex, totalSteps, showNavigate = true }) {
    return (
        <div className={`${Styles.mainContainer_manual} 'page-break'`}>
            <Typography
                variant='h6'
                fontWeight={600}
            >
                {`${data?.title}`}
            </Typography>
            {data?.description && <Typography
                variant='subtitle1'
                sx={{ whiteSpace: 'pre-wrap', pl: '1em' }}
            >
                {data?.description}
            </Typography>}
            {data?.imageUrl && <div className={Styles.imageContainer}>
                <img alt='icon' src={data?.imageUrl} />
            </div>}

            {data?.steps && <div className={Styles.keyPointsContainer}>
                {
                    data?.steps?.split('\n')?.map((point, index) => (
                        <div
                            key={`${point}_${index}`}
                            className={Styles.keyPoints}
                        >
                            <FeatherIcon
                                icon='chevrons-right'
                                className={Styles.keyPointIcon}
                                size='4em'
                            />

                            <Typography
                                variant='body1'
                            >
                                {point}
                            </Typography>
                        </div>
                    ))
                }
            </div>}
            {showNavigate &&
                <>
                    <button onClick={() => { callback('prev') }} disabled={currentIndex === 0} className={`${Styles.navButton} ${Styles.navButton1}`}> <FeatherIcon icon='chevron-left' /> </button>
                    <button onClick={() => { callback('forward') }} disabled={currentIndex === totalSteps - 1} style={{ right: '0.5em' }} className={`${Styles.navButton} ${Styles.navButton2}`}> <FeatherIcon icon='chevron-right' /> </button>
                </>
            }
        </div>
    )
}
